<div class="grid-container margin-top">
  <button class="linkButton margin-bottom" routerLink="/admin/manage-groups"><span class="ascii-full-height">&laquo;</span> All Groups</button>
  @if (currentGroup) {
    <form [formGroup]="groupDetailsForm">
      @if (!isEditingGroupName) {
        <div class="margin-bottom heading-border">
          <div class="flex">
            <h2 class="display-inline-block no-margin" aria-label="Group Name">&#42; {{currentGroupName}}</h2>
            <button (click)="isEditingGroupName = true" class="minor-margin-left no-margin-bottom" aria-label="Edit Group Name" title="Edit Group Name">
              <svg-icon icon="icon-pencil" class="dark-gray" aria-hidden="true"></svg-icon>
            </button>
          </div>
          @if (hasGroupNameError) {
            <div>
              @if (groupDetailsForm.get('nameInput').hasError('required')) {
                <small class="error">
                  Group name is required
                </small>
              }
            </div>
          }
        </div>
      } @else {
        <div class="flex margin-bottom">
          <label for="nameInput" class="show-for-sr">Enter Group Name</label>
          <input type="text" formControlName="nameInput" id="nameInput" placeholder="Enter Group Name" required [(ngModel)]="currentGroup.displayName" class="no-margin" />
          <button (click)="isEditingGroupName = false" class="minor-margin-left no-margin-bottom" [disabled]="hasGroupNameError" title="Save Group Name" aria-label="Save Group Name">
            <svg-icon icon="icon-save" class="small dark-gray" aria-hidden="true"></svg-icon>
          </button>
        </div>
        @if (hasGroupNameError) {
          <div class="error-container">
            @if (groupDetailsForm.get('nameInput').hasError('required')) {
              <small class="error">
                Group name is required
              </small>
            }
          </div>
        }
      }
      <div class="grid-x">
        <div class="cell medium-6">
          <div class="tiny">
            <label class="vertical-align-middle inline minor-margin-right" for="currentGroup">Group is active:</label>
            <input class="no-margin-bottom vertical-align-middle" type="checkbox" [checked]="currentGroup.active" id="currentGroup" (change)="currentGroup.active = !currentGroup.active" />
          </div>
        </div>
        <div class="cell medium-6">
          <div class="grid-x">
            <div class="cell">
              <label>Group Type:</label>
            </div>
            <div class="cell small-6">
              <label class="cursor-pointer">
                <input type="radio" name="groupType" value="internal" [checked]="currentGroup.groupType==='internal'" (change)="updateGroupType('internal')" />
                <span>Internal</span>
              </label>
            </div>
            <div class="cell small-6">
              <label class="cursor-pointer">
                <input type="radio" name="groupType" value="external" [checked]="currentGroup.groupType==='external'" (change)="updateGroupType('external')" />
                <span>External</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <admin-permission-selector [group-title]="'System Permissions'" [selected-title]="'Selected System Permissions'" [available-title]="'Available System Permissions'" [elements]="allPermissions.permissions" [initial-set]="currentGroup.permissions" (changed)="updateSystemClaims($event)">
      </admin-permission-selector>
      <admin-permission-selector [group-title]="'Workflow Permissions'" [selected-title]="'Selected Workflow Permissions'" [available-title]="'Available Workflow Permissions'" [elements]="allPermissions.workflows" [initial-set]="currentGroup.permissions" (changed)="updateWorkflowClaims($event)">
      </admin-permission-selector>
      <admin-permission-selector [group-title]="'Dashboard Permissions'" [selected-title]="'Selected Dashboard Permissions'" [available-title]="'Available Dashboard Permissions'" [elements]="allPermissions.dashboards" [initial-set]="currentGroup.permissions"
      (changed)="updateDashboardClaims($event)"></admin-permission-selector>
      <admin-permission-selector [group-title]="'View Permissions'" [selected-title]="'Selected View Permissions'" [available-title]="'Available View Permissions'" [elements]="allPermissions.widgets" [initial-set]="currentGroup.permissions"
      (changed)="updateWidgetClaims($event)"></admin-permission-selector>
      <admin-user-selector [group-title]="'Users'" [selected-title]="'Selected Users'" [available-title]="'Available Users'" [elements]="allUsers" [initial-set]="initialUserSet" (changed)="updateUsers($event)"> </admin-user-selector>
    </form>
  }
</div>
